import { MailOutlined } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { Field, Form, Formik } from 'formik';
import { useState } from 'react';
import * as Yup from "yup";
import { useSendResetPasswordEmailMutation } from '../../generated/graphql';
import FieldText from '../FieldText/FieldText';
import styles from './ForgotPassword.module.scss';

const Feedback = () => {
    return (
        <div className={styles.Feedback}>
            <Typography variant="h4" color="primary">Obrigado</Typography>
            <Typography variant="h5" color="secondary">Se a sua conta estiver associada a este email vai receber nos próximos instantes um email com instruções para redefinir a sua senha.</Typography>
            <Typography variant="h5" color="secondary">Por favor verifique o seu email, inclusive a pasta SPAM.</Typography>
        </div>
    )
}

const ForgotPassword = () => {

    const [sendResetEmail] = useSendResetPasswordEmailMutation()
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [submitted, setSubmitted] = useState<boolean>(false);

    const schema = Yup.object().shape({
        email: Yup.string().email().required().default(""),
    })

    const handleSubmit = async (values: any) => {
        const response = await sendResetEmail({ variables: { email: values.email } });
        if (!response?.data?.sendResetPasswordEmail) {
            setErrorMessage("Não foi possível enviar email. Tente mais tarde por favor.");
        } else {
            setSubmitted(true)
        }
    }

    if (submitted) return <Feedback />

    return (
        <Formik onSubmit={handleSubmit} initialValues={schema.cast({})} validationSchema={schema}>
            {({ isSubmitting }) => (
                <Form id={styles.ResetPasswordForm}>
                    <Typography variant="h4" color="secondary">Recuperar Senha</Typography>

                    <div>
                        <div>{errorMessage}</div>
                        <Typography variant="h5" color="primary">Por favor introduza o email associado à sua conta para receber um email com instruções para repor senha.</Typography>

                        <Field
                            component={FieldText}
                            label="Email"
                            name="email"
                            required
                            fullWidth
                            autoFocus
                            autoComplete="current-username"
                            InputProps={{
                                startAdornment: <MailOutlined color="primary" />
                            }}

                        />

                        <Button
                            color="primary"
                            variant="contained"
                            type="submit"
                            disabled={isSubmitting}
                        >
                            enviar email
                        </Button>
                    </div>
                </Form>
            )}
        </Formik >
    );
};

export default ForgotPassword
